import { render, staticRenderFns } from "./jtDetail.vue?vue&type=template&id=20aebc39&scoped=true&"
import script from "./jtDetail.vue?vue&type=script&lang=js&"
export * from "./jtDetail.vue?vue&type=script&lang=js&"
import style0 from "./jtDetail.vue?vue&type=style&index=0&id=20aebc39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aebc39",
  null
  
)

export default component.exports